import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { disableAnalytics, initializeAnalytics } from '../../services/analyticsService';

const STORAGE_KEY = 'spilia-cookie-consent';
type Consent = 'accepted' | 'declined' | null;

export default function CookieConsentBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY) as Consent;
    if (saved === 'accepted') initializeAnalytics();
    else if (!saved) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    initializeAnalytics();
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    disableAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" aria-live="polite" aria-label="Cookie consent">
      <p className="cookie-banner__message">{t('cookie.message')}</p>
      <div className="cookie-banner__actions">
        <button type="button" className="btn btn--ghost btn--sm" onClick={decline}>
          {t('cookie.decline')}
        </button>
        <button type="button" className="btn btn--gold btn--sm" onClick={accept}>
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
}
